import React, { Component, Fragment } from "react";
import { Icon, Toast, Picker, Modal } from "antd-mobile";
import { Helmet } from "react-helmet";
import copy from "copy-to-clipboard";
import Http from "../../config/axiosUtils";
import isWeiXin from "../../config/judgeDevice";
import wxShare from "../../config/wxShare";
import QrocdeSwiper from "./QrocdeSwiper";
import "../../assets/scss/InviteTeam/inviteHome.scss";
import tipImg from "../../assets/images/invite/tip@2x.png";
// import customNewImg from "../../assets/images/invite/custom_new@2x.png";
// import cutomNewFbdImg from "../../assets/images/invite/customNew.jpg"
// import fxjlImg from "../../assets/images/invite/fxjl@2x.png";
// import haibaoImg from "../../assets/images/invite/haibao@2x.png";
import jtIcon from "../../assets/images/invite/jt@2x.png";
import Poster from "../../components/Poster/Poster";
import { isIOS } from "../../config/env";
import InviteHomeBottom from '../../components/Home/InviteHomeBottom';
const alert = Modal.alert;

class InviteHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "team",
      codeUrl: "", //二维码
      showCode: false, //展示二维码
      isShowSharePopup: false, // 是否展示分享弹窗
      whichTagNameInput: "",
      tagList: [],
      whichTagIdSelected: "",
      expireOptions: [
        {
          label: "15分钟内有效",
          value: 1,
        },
        {
          label: "24小时有效",
          value: 2,
        },
        {
          label: "30天有效",
          value: 3,
        },
        {
          label: "永久有效",
          value: 4,
        },
      ],
      whichTagExpire: 1,
      whichTagExpireShow: "请选择有效时间",
      isShowPoster: false,
      posterUrl: "",
      posterPostData: {},
      shareLink: "",
      isCreateRecordIng: false,
      msg: "", //
      backCodeImg:'',
      canSpread: true,
      open: true,
      expandStr: "我要推广",
      productCode: "100",
      productID: "",
    };
  }
  componentDidMount() {
    Http.post(`/tag/check`).then((res) => {
      const { msg } = res;
      this.setState({
        msg,
      });
    });

    this.setState(
      {
        type: this.props.match.params.type,
        productCode: this.props.location.state ? (this.props.location.state.codeText ? this.props.location.state.codeText : "100") : "100",
        productID: this.props.location.state ? (this.props.location.state.productID ? this.props.location.state.productID : "99e7ec0c8eae4ee3ab3fc55e9389aedf") : "99e7ec0c8eae4ee3ab3fc55e9389aedf"
      },
      () => {
        sessionStorage.setItem("userType", this.props.match.params.type);
        this.fetchData();
        if (this.state.type === "custom") {
          this.fetchBackgroundImg();
        }
        this.getTagList();
      }
    );
  }

  fetchData = async () => {
    const path = `/spread/web/user/account/invite/shareInfo/${this.state.type !== "custom" ? 1 : 0}`;
    const res = await Http.get(path);
    if (res.code === 0) {
      this.setState({
        codeUrl: res.data.url,
      });
      wxShare.call(this, res.data);
    } else {
      Toast.fail(res.msg, 2);
    }
  };

  copyUrl = () => {
    copy(this.state.codeUrl);
    Toast.info("复制成功！", 2);
  };

  shareToWx = () => {
    if (!isWeiXin()) {
      Toast.info("请用微信打开进行分享！", 2);
      return;
    }
    Toast.info("请点击右上角进行分享！", 2);
  };

  // 展示分享弹窗
  showSharePopup = () => {
    if (this.state.msg) {
      Toast.info(this.state.msg, 2);
    } else {
      this.setState({
        isShowSharePopup: true,
      });
    }
  };

  // 隐藏分享弹窗
  hideSharePopup = () => {
    this.setState({
      isShowSharePopup: false,
      whichTagNameInput: "",
      whichTagIdSelected: "",
      whichTagExpire: null,
      whichTagExpireShow: "请选择有效时间",
      isShowPoster: false,
      posterUrl: "",
      posterPostData: {},
    });
  };

  // 前往分享记录
  toInviteShareList = () => {
    const { history } = this.props;
    history.push("/InviteShareList");
  };

  // 新增标签
  addTag = async () => {
    if (this.state.whichTagNameInput.length > 6) {
      Toast.fail("字符过长，最多不超过6个字符");
      return;
    }
    const path = "/tag/add";
    const postData = {
      name: this.state.whichTagNameInput,
    };
    const res = await Http.post(path, postData);
    if (res.code === 0) {
      Toast.info("添加成功", 2);
      this.getTagList(true);
    } else {
      Toast.fail(res.msg, 2);
    }
  };

  // 获取标签列表
  getTagList = async (isAdd) => {
    const path = "/tag/lists";
    const res = await Http.post(path, {productSpreadId:this.state.productID});
    const whichTagIdSelected = this.state.whichTagIdSelected;
    if (res.code === 0) {
      this.setState(
        {
          tagList: res.data,
          whichTagIdSelected: res.data && res.data.length > 0 && isAdd ? res.data[0].tagId : whichTagIdSelected,
        },
        () => {
          isAdd && this.getExpireOptions();
        }
      );
    }
  };

  // 修改标签名
  changeTagName = (e) => {
    this.setState({
      whichTagNameInput: e.target.value,
    });
  };

  // 修改标签选择
  changeTagSelect = (tagId) => {
    this.setState(
      {
        whichTagIdSelected: tagId,
      },
      () => {
        this.getExpireOptions();
      }
    );
  };

  // 获取有效期选项
  getExpireOptions = async () => {
    const path = "/tag/get/expire";
    const postData = {
      tagId: this.state.whichTagIdSelected,
      productSpreadId: this.state.productID
    };
    const res = await Http.post(path, postData);
    console.log(res);
    const expireOptions = [];
    res.code === 0 &&
      res.data &&
      res.data.length > 0 &&
      res.data.forEach((ele) => {
        let label = "";
        if (ele === 1) {
          label = "15分钟内有效";
        } else if (ele === 2) {
          label = "24小时有效";
        } else if (ele === 3) {
          label = "30天有效";
        } else if (ele === 4) {
          label = "永久有效";
        }
        const obj = {
          label,
          value: ele,
        };
        expireOptions.push(obj);
      });
    this.setState({
      expireOptions,
      whichTagExpire: null,
      whichTagExpireShow: "请选择有效时间",
    });
  };

  // 修改有效期
  changeTagExpire = (e) => {
    console.log(e);
    let whichTagExpireShow = "";
    if (e[0] === 1) {
      whichTagExpireShow = "15分钟内有效";
    } else if (e[0] === 2) {
      whichTagExpireShow = "24小时有效";
    } else if (e[0] === 3) {
      whichTagExpireShow = "30天有效";
    } else if (e[0] === 4) {
      whichTagExpireShow = "永久有效";
    }
    this.setState(
      {
        isShowExpireSelectPopup: false,
        whichTagExpireShow,
        whichTagExpire: e[0],
      },
      () => {
        // this.getShareLink();
      }
    );
  };

  // 展示有效期弹窗
  showExpireSelectPopup = () => {
    if (!this.state.whichTagIdSelected) {
      Toast.info("请先选择标签，再选择有效时间", 2);
      return;
    }
    this.setState({
      isShowExpireSelectPopup: true,
    });
  };

  // 隐藏有效期弹窗
  hideExpireSelectPopup = () => {
    this.setState({
      isShowExpireSelectPopup: false,
    });
  };
  // 获取弹窗的分享链接（因为ios不支持复制异步的文字，所以只能每次修改标签或者有效期，都请求链接）
  getShareLink = async () => {
    if (!this.state.whichTagIdSelected) {
      return;
    }
    const postData = {
      expire: this.state.whichTagExpire,
      tagId: this.state.whichTagIdSelected,
      productSpreadId: this.state.productID
    };
    const path = "/tag/getUrl";
    const res = await Http.post(path, postData);
    this.setState({
      shareLink: res.data.url,
    });
  };
  // 复制弹窗的分享链接
  copyShareLink = async () => {
    this.setState(
      {
        isCreateRecordIng: true,
      },
      async () => {
        if (!this.state.whichTagIdSelected) {
          Toast.info("请选择标签", 2);
          this.setState({
            isCreateRecordIng: false,
          });
          return;
        }
        if (!this.state.whichTagExpire) {
          Toast.info("请选择有效时间", 2);
          this.setState({
            isCreateRecordIng: false,
          });
          return;
        }
        // copy(this.state.shareLink);
        // Toast.info('复制成功！', 2);
        const postData = {
          expire: this.state.whichTagExpire,
          tagId: this.state.whichTagIdSelected,
          productSpreadId: this.state.productID
        };
        const path = "/tag/getUrl";
        const res = await Http.post(path, postData);
        copy(res.data.url);
        Toast.info("复制成功！", 2);
        this.setState({
          isCreateRecordIng: false,
        });
      }
    );
  };
  // 保存弹窗的分享海报
  savaPoster = async () => {
    this.setState(
      {
        isCreateRecordIng: true,
      },
      async () => {
        if (!this.state.whichTagIdSelected) {
          Toast.info("请选择标签", 2);
          this.setState({
            isCreateRecordIng: false,
          });
          return;
        }
        if (!this.state.whichTagExpire) {
          Toast.info("请选择有效时间", 2);
          this.setState({
            isCreateRecordIng: false,
          });
          return;
        }
        const postData = {
          expire: this.state.whichTagExpire,
          tagId: this.state.whichTagIdSelected,
          productSpreadId: this.state.productID
        };
        const path = "/tag/getUrl";
        const res = await Http.post(path, postData);
        if (res.code === 0) {
          this.setState({
            isShowPoster: true,
            posterUrl: "/source/manager/mergeLists",
            posterPostData: {
              tagRelationId: res.data.tagRelationId,
              productSpreadId:this.state.productID,
              useType: 1,
            },
            isCreateRecordIng: false,
          });
        }
      }
    );
  };
  hidePoster = () => {
    this.setState({
      isShowPoster: false,
      posterUrl: "",
      posterPostData: {},
    });
    this.hideSharePopup();
  };
  handleCopy = (e, url) => {
    // clipboardData 可能是 null
    e.clipboardData && e.clipboardData.setData("text/plain", url);
    e.preventDefault();
    // removeEventListener 要传入第二个参数
    document.removeEventListener("copy", this.handleCopy);
  };
  expandAction = () => {
    if (this.state.canSpread) {
      if(this.state.open) {
        this.showSharePopup()
      } else {
        alert("温馨提醒","已暂停进件，请等待后续通知",[{text:'知道了',onPress:() => {}}]);
      }
      
      
    } else {
      alert("温馨提醒","已通知到团长",[{text:'知道了',onPress:() => {}}]);
    }
  }
  // 获取背景图片
  fetchBackgroundImg = async() => {
    if (this.state.productCode) {
      const path = "/product/spread/info/" + this.state.productID;
      const res = await Http.get(path);
      if (res.code === 0) {
        let expandStr = '';
        if(res.data.canSpread) {
          if(res.data.open ) {
            expandStr = '我要推广'
          } else {
            expandStr = '系统升级中，已暂停进件'
          }
        } else {
          
          expandStr = '喊团队长开通该产品推广权限'
        }
        this.setState({
          backCodeImg:res.data.backgroundImg,
          canSpread: res.data.canSpread,
          open: res.data.open,
          expandStr: expandStr
        });
      }
    }
  }
  render() {
    const {
      type,
      isShowSharePopup,
      whichTagNameInput,
      tagList,
      whichTagIdSelected,
      expireOptions,
      isShowExpireSelectPopup,
      whichTagExpire,
      whichTagExpireShow,
      isShowPoster,
      posterUrl,
      posterPostData,
      isCreateRecordIng,
    } = this.state;
    return (
      <Fragment>
        {type !== "custom" && (
          <div className={`inviteHome ${type}`}>
            <Helmet>
              <title>{type === "custom" ? "邀请客户" : type === "team" ? "邀请队员" : "邀请合伙人"}</title>
            </Helmet>
            <div className={`content ${type}`}>
              <ul>
                <li onClick={() => this.setState({ showCode: true })}>
                  <img src={require(`../../assets/images/invite/${type}Code@2x.png`).default} alt="" />
                  <div>分享二维码</div>
                </li>
                <li onClick={this.shareToWx}>
                  <img src={require(`../../assets/images/invite/${type}Wx@2x.png`).default} alt="" />
                  <div>分享到微信</div>
                </li>
                <li onClick={this.copyUrl}>
                  <img src={require(`../../assets/images/invite/${type}Copy@2x.png`).default} alt="" />
                  <div>复制我的链接</div>
                </li>
              </ul>
            </div>
            {this.state.showCode && (
              <div className="mask">
                <div className="topClose" onClick={() => this.setState({ showCode: false })}>
                  <Icon type="cross" />
                </div>

                <QrocdeSwiper></QrocdeSwiper>
                {/* <p className="erro" onClick={() => alert(1111)}>图片异常？点击刷新</p> */}
              </div>
            )}
            {type === "custom" && (
              <div className="customTips">
                <img src={tipImg} width="16" alt="" /> 推广须知：推广富宝袋过程中，严禁任何线下收费。
              </div>
            )}
          </div>
        )}
        {type === "custom" && (
          <div className={`new-invite-home new-invite-home-custom`}>
            <Helmet>
              <title>{type === "custom" ? "邀请客户" : type === "team" ? "邀请队员" : "邀请合伙人"}</title>
            </Helmet>
            <div className={`new-invite-home-content`}>
              <img src= {this.state.backCodeImg} alt="" className="new-invite-home-content-bg" />
              {/*<div className="new-invite-home-content-operate">*/}
              {/*  <ul className="new-invite-home-content-ul">*/}
              {/*    <li>*/}
              {/*      <img src={haibaoImg} alt="" onClick={this.showSharePopup} />*/}
              {/*      <div>分享海报</div>*/}
              {/*    </li>*/}
              {/*    <li>*/}
              {/*      <img src={fxjlImg} alt="" onClick={this.toInviteShareList} />*/}
              {/*      <div>我的分享记录</div>*/}
              {/*    </li>*/}
              {/*  </ul>*/}
              {/*</div>*/}
              {/*{type === "custom" && (*/}
              {/*  <div className="new-invite-home-content-customTips">*/}
              {/*    <img src={tipImg} width="16" alt="" /> 推广须知：推广富宝袋过程中，严禁任何线下收费。*/}
              {/*  </div>*/}
              {/*)}*/}
            </div>
            {/*<div className="new-invite-home-footer">*/}
            {/*  <div className="new-invite-home-footer-text">———— 富金富蓝领数科平台 ————</div>*/}
            {/*  <div className="new-invite-home-footer-phone">(免费咨询热线：4009-303-606)</div>*/}
            {/*</div>*/}
            <InviteHomeBottom expandFunc={this.expandAction} expandStr={this.state.expandStr} productID={this.state.productID}></InviteHomeBottom>
            {this.state.showCode && (
              <div className="mask">
                <div className="topClose" onClick={() => this.setState({ showCode: false })}>
                  <Icon type="cross" />
                </div>
                <QrocdeSwiper></QrocdeSwiper>
                 <p className="erro" onClick={() => alert(1111)}>图片异常？点击刷新</p>
              </div>
            )}
          </div>
        )}
        {isShowSharePopup && (
          <div className="share-popup">
            <div className={`share-popup-content ${isShowSharePopup ? "up-box" : "down-box"}`}>
              <div className="share-popup-content-header">
                <div className="share-popup-content-header-title">分享</div>
                <div className="share-popup-content-header-close" onClick={this.hideSharePopup}>
                  取消
                </div>
              </div>
              <div className="share-popup-content-prompt">挣推严厉禁止经纪人线下收费行为，如经发现，将封号处理</div>
              <div className="share-popup-content-operate">
                <div className="share-popup-content-operate-title">标签</div>
                <div className="share-popup-content-operate-addtag">
                  <input
                    type="text"
                    className="share-popup-content-operate-addtag-input"
                    placeholder="请输入新建的标签名称"
                    onChange={(e) => {
                      this.changeTagName(e);
                    }}
                    value={whichTagNameInput}
                  />
                  <div className="share-popup-content-operate-addtag-btn" onClick={this.addTag}>
                    新建标签
                  </div>
                </div>
                <div className="share-popup-content-operate-taglist">
                  {tagList &&
                    tagList.length > 0 &&
                    tagList.map((ele, index) => {
                      return (
                        <div
                          className={`share-popup-content-operate-taglist-item ${whichTagIdSelected === ele.tagId ? "share-popup-content-operate-taglist-item-selected" : ""}`}
                          onClick={() => {
                            this.changeTagSelect(ele.tagId);
                          }}
                          key={index}
                        >
                          {ele.name}
                        </div>
                      );
                    })}
                </div>
                <div className="share-popup-content-operate-title">有效时间</div>
                <div className="share-popup-content-operate-expire" onClick={this.showExpireSelectPopup}>
                  <span>{whichTagExpireShow}</span>
                  <img src={jtIcon} alt="" />
                </div>
                <Picker
                  data={expireOptions}
                  visible={isShowExpireSelectPopup}
                  cols={1}
                  value={whichTagExpire}
                  onOk={(e) => {
                    this.changeTagExpire(e);
                  }}
                  onDismiss={this.hideExpireSelectPopup}
                />
              </div>
              <div className="share-popup-content-btn">
                {!isIOS && (
                  <div className="share-popup-content-btn-copy" onClick={this.copyShareLink}>
                    复制链接
                  </div>
                )}
                <div className="share-popup-content-btn-save" onClick={this.savaPoster}>
                  保存海报
                </div>
                {isCreateRecordIng && <div className="share-popup-content-btn-masker"></div>}
              </div>
            </div>
          </div>
        )}
        {isShowPoster && (
          <div className="mask">
            <div className="topClose" onClick={this.hidePoster}>
              <Icon type="cross" />
            </div>
            <Poster path={posterUrl} postData={posterPostData} />
          </div>
        )}
      </Fragment>
    );
  }
}

export default InviteHome;
